var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18.608,
    height: 17.576,
    rx: 7.5,
    fill: "#24A95D",
    stroke: "#24A95D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7686 12.4792L5.9736 9.68418C5.80568 9.51627 5.80568 9.244 5.9736 9.07607L6.58169 8.46796C6.74961 8.30002 7.02189 8.30002 7.18981 8.46796L9.07265 10.3508L13.1055 6.31796C13.2734 6.15004 13.5457 6.15004 13.7136 6.31796L14.3217 6.92607C14.4896 7.09399 14.4896 7.36625 14.3217 7.53418L9.37671 12.4792C9.20877 12.6471 8.93651 12.6471 8.7686 12.4792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.a3c2232ca731a76889dfea792a74479a.svg";
export { ForwardRef as ReactComponent };